import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAdmin from './admin.reducer';

export const selectAdminState = createFeatureSelector<fromAdmin.State>(fromAdmin.adminFeatureKey);

export const selectAdmins = createSelector(selectAdminState, (state) => state.admins);
export const selectIsLoading = createSelector(selectAdminState, (state) => state.isLoading);
export const selectIsComplete = createSelector(selectAdminState, (state) => state.isComplete);
export const selectError = createSelector(selectAdminState, (state) => state.error);
